export default {
  mounted(el, binding) {
    setTimeout(() => {
      const hasPermission = checkPermission(binding.value); // 假设这个函数根据传入的权限值检查用户是否有权限
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el); // 如果没有权限，移除元素
      }
    }, 100);
  },
};
const checkPermission = (val) => {
  console.log(val);
  return true;
};
